<template>
    <div class="sc-scenario">
        <pui-form-group
            :label="$t('results.kpiAnalysis.selector.selectScenario')"
            :cta-label="$t('form.clear')"
            :has-cta="true"
            :cta-callback="clearScenario"
            :show-required-label="true"
            :has-label-padding="false"
            label-for="selectScenario"
        >
            <benchmarking-type-ahead
                :ref="REF_CONSTANTS.TYPEAHEAD"
                v-model="selectedScenario"
                :placeholder="$t('results.kpiAnalysis.selector.selectPlaceholder')"
                :request-promise-generator="scenariosRequestPromiseGenerator"
            />
        </pui-form-group>
    </div>
</template>

<script lang="ts">
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ManagedAbortControllers } from '@/mixins/managed-abort-controllers';
import { EngineRunServiceProxy } from '@/service-proxies/service-proxies.g';
import { ScenarioCompareScenarioSelectOption } from '@/models/results/scenario-compare';
import BenchmarkingTypeAhead from '@/components/inputs/benchmarking-type-ahead/benchmarking-type-ahead.vue';
import { SCENARIO_STATUS } from '@/config/status';

const REF_CONSTANTS = {
    TYPEAHEAD: 'typeahead',
} as const;

@Component({
    components: {BenchmarkingTypeAhead}
})
export default class ScenarioCompareScenarioSelector extends mixins(ManagedAbortControllers) {
    private readonly engineRunService = new EngineRunServiceProxy();
    private readonly REF_CONSTANTS = REF_CONSTANTS;

    private selectedScenario: ScenarioCompareScenarioSelectOption | null = null;

    $refs!: {
        [REF_CONSTANTS.TYPEAHEAD]?: BenchmarkingTypeAhead,
    };

    private async scenariosRequestPromiseGenerator(query: string, signal: AbortSignal): Promise<ScenarioCompareScenarioSelectOption[]> {
        const statuses = [
            Number(SCENARIO_STATUS.ENGINE_RUN_COMPLETED),
            Number(SCENARIO_STATUS.ENGINE_RUN_FAILED)
        ];

        const response = await this.engineRunService.list7(undefined, undefined, statuses, 1, 20, query, undefined, signal);
        return response.result.items?.map(e => ({
            label: e.name ?? '',
            value: e.id,
            extraData: e,
        })) ?? [];
    }

    @Watch('selectedScenario')
    private onSelectedScenarioChange(newSelectedScenario: ScenarioCompareScenarioSelectOption | undefined): void {
        this.clearAppliedFilters();
        this.$emit('change:scenario', newSelectedScenario);
    }

    private clearAppliedFilters(): void {
        this.$store.dispatch('results/scenarioCompare/clearAppliedFilters');
    }

    private clearScenario(): void {
        this.$refs.typeahead?.clearInput();
    }
}
</script>
